module.exports = __webpack_public_path__ + "static/media/screenshot_before.dafe150e.png";